import React, { useState, useEffect } from 'react';

const HomePage = () => {
  const [expandedFaq, setExpandedFaq] = useState<number | null>(null);

  // TODO: Replace with your Stripe Payment Link URL
  const STRIPE_PAYMENT_LINK = 'https://buy.stripe.com/YOUR_PAYMENT_LINK_HERE';
  
  // TODO: Replace with your Calendly link
  const CALENDLY_LINK = 'https://calendly.com/YOUR_LINK_HERE';

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://fullness-life.kit.com/e923a152bb/index.js';
    script.async = true;
    script.setAttribute('data-uid', 'e923a152bb');
    const container = document.getElementById('ck_embed_form');
    if (container) {
      container.appendChild(script);
    }
    return () => {
      if (container && container.contains(script)) {
        container.removeChild(script);
      }
    };
  }, []);

  const faqs = [
    {
      q: "Is this just for business or for personal use too?",
      a: "Both. We cover AI for your business — content, automation, insights, workflows — and for your daily life. How to use AI to learn faster, make better decisions, manage information, and stay ahead. The goal is to make AI a natural extension of how you operate."
    },
    {
      q: "Do I need technical skills?",
      a: "No. If you can use a smartphone, you can use AI effectively. I come from a DevOps and engineering background so I handle the technical complexity — you focus on applying it to your life and work."
    },
    {
      q: "How do I stay up to date after the programme?",
      a: "Part of the mentorship is teaching you HOW to stay current — the sources, communities, and filters I use as an AI super user to cut through noise. You'll also get AI trend briefings during our time together so you see what's coming, not just what's here."
    },
    {
      q: "What if it doesn't work for me?",
      a: "It will. But if you show up to every session, do the work, and don't see measurable results within 30 days — I'll keep coaching you for free until you do. Zero risk."
    },
    {
      q: "Can I pay in instalments?",
      a: "Yes. Reach out on the discovery call and we can arrange a 2-payment plan."
    },
    {
      q: "Is this a course or pre-recorded content?",
      a: "Neither. This is live, 1-on-1 mentorship tailored entirely to YOU — your goals, your workflows, your life. No generic videos. Every session is personalised and we build things together in real time."
    }
  ];

  const results = [
    { metric: "10-20hrs", label: "saved per week through AI workflows" },
    { metric: "5-10x", label: "faster content, insights & decisions" },
    { metric: "Always", label: "up to date with the latest AI tools" },
    { metric: "£0", label: "risk — guaranteed results" }
  ];

  return (
    <div className="bg-black text-white min-h-screen" style={{ 
      fontFamily: "'-apple-system', 'BlinkMacSystemFont', 'SF Pro Display', 'SF Pro Text', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"
    }}>
      <style dangerouslySetInnerHTML={{
        __html: `
          @keyframes logoFloat {
            0%, 100% { transform: translateY(0px) rotate(0deg); }
            50% { transform: translateY(-8px) rotate(1deg); }
          }
          
          @keyframes wireframeShift {
            0% { background-position: 0 0, 0 0, 0 0, 0 0; }
            100% { background-position: 12px 12px, 12px 12px, 8px 8px, -8px 8px; }
          }
          
          @keyframes pulseCorner {
            0%, 100% { opacity: 0.3; transform: scale(1); }
            50% { opacity: 0.8; transform: scale(1.1); }
          }

          @keyframes fadeInUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }

          .fade-in-up { animation: fadeInUp 0.8s ease forwards; }
          .fade-in-up-delay-1 { animation-delay: 0.2s; opacity: 0; }
          .fade-in-up-delay-2 { animation-delay: 0.4s; opacity: 0; }
          .fade-in-up-delay-3 { animation-delay: 0.6s; opacity: 0; }

          .hp-cta-button {
            background-color: #f5f5dc;
            color: #000;
            border: none;
            padding: 18px 48px;
            font-size: 1.1rem;
            font-weight: 700;
            letter-spacing: 0.02em;
            cursor: pointer;
            transition: all 0.3s ease;
            text-decoration: none;
            display: inline-block;
            font-family: inherit;
          }

          .hp-cta-button:hover {
            background-color: #e6e6cd;
            transform: translateY(-3px);
            box-shadow: 0 8px 32px rgba(245, 245, 220, 0.3);
          }

          .hp-cta-outline {
            background-color: transparent;
            color: #f5f5dc;
            border: 2px solid #f5f5dc;
            padding: 16px 44px;
            font-size: 1rem;
            font-weight: 600;
            letter-spacing: 0.02em;
            cursor: pointer;
            transition: all 0.3s ease;
            text-decoration: none;
            display: inline-block;
            font-family: inherit;
          }

          .hp-cta-outline:hover {
            background-color: rgba(245, 245, 220, 0.1);
            transform: translateY(-2px);
          }

          .section-divider {
            width: 60px;
            height: 1px;
            background: rgba(245, 245, 220, 0.3);
            margin: 0 auto 3rem;
          }

          .pain-point {
            border-left: 2px solid rgba(245, 245, 220, 0.3);
            padding-left: 1.5rem;
            margin-bottom: 1.5rem;
            transition: all 0.3s ease;
          }

          .pain-point:hover { border-left-color: #f5f5dc; }

          .faq-item {
            border-bottom: 1px solid rgba(245, 245, 220, 0.15);
            cursor: pointer;
            transition: all 0.3s ease;
          }

          .faq-item:hover { background: rgba(245, 245, 220, 0.03); }

          .result-card {
            border: 1px solid rgba(245, 245, 220, 0.15);
            padding: 2rem;
            text-align: center;
            transition: all 0.3s ease;
          }

          .result-card:hover {
            border-color: rgba(245, 245, 220, 0.4);
            transform: translateY(-4px);
          }

          .step-number {
            width: 48px;
            height: 48px;
            border: 2px solid #f5f5dc;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 700;
            font-size: 1.2rem;
            color: #f5f5dc;
            flex-shrink: 0;
          }

          .included-item {
            display: flex;
            align-items: flex-start;
            gap: 1rem;
            margin-bottom: 1.25rem;
          }

          .checkmark {
            color: #f5f5dc;
            font-size: 1.2rem;
            flex-shrink: 0;
            margin-top: 2px;
          }

          .install-card {
            border: 1px solid rgba(245, 245, 220, 0.12);
            padding: 2rem;
            transition: all 0.3s ease;
          }
          .install-card:hover {
            border-color: rgba(245, 245, 220, 0.35);
            transform: translateY(-4px);
          }

          /* ConvertKit overrides */
          .ck-form .ck-input {
            width: 100%;
            background: rgba(255, 255, 255, 0.95);
            font-size: 15px;
            padding: 12px 16px;
            border: 1px solid rgba(245, 245, 220, 0.3);
            border-radius: 4px;
            font-weight: 700;
            color: #000;
            transition: all 0.3s ease;
            font-family: inherit;
          }
          .ck-form .ck-input:focus {
            outline: none;
            border-color: #f5f5dc;
            box-shadow: 0 0 0 2px rgba(245, 245, 220, 0.2);
            background: #ffffff;
          }
          .ck-form .ck-input::placeholder { color: rgba(0, 0, 0, 0.6); opacity: 1; }
          .ck-form .ck-submit {
            background-color: #f5f5dc;
            color: #000;
            border: none;
            border-radius: 4px;
            font-weight: 600;
            font-size: 15px;
            padding: 12px 24px;
            cursor: pointer;
            transition: all 0.3s ease;
            width: 100%;
            font-family: inherit;
          }
          .ck-form .ck-submit:hover {
            background-color: #e6e6cd;
            transform: translateY(-2px);
            box-shadow: 0 4px 16px rgba(245, 245, 220, 0.3);
          }

          @media (max-width: 768px) {
            .results-grid { grid-template-columns: 1fr 1fr !important; }
          }
          @media (max-width: 480px) {
            .results-grid { grid-template-columns: 1fr !important; }
          }
        `
      }} />

      {/* ====== HERO ====== */}
      <section style={{ 
        minHeight: '100vh', 
        display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', 
        padding: '2rem', position: 'relative'
      }}>
        <div style={{ maxWidth: '800px', textAlign: 'center' }}>
          <div className="fade-in-up" style={{ marginBottom: '2.5rem' }}>
            <div style={{ width: '90px', height: '90px', margin: '0 auto', animation: 'logoFloat 4s ease-in-out infinite' }}>
              <img 
                src="/images/ChatGPT_Image_Jun_5__2025__01_11_15_PM-removebg-preview.png"
                alt="Fullness Life"
                style={{ width: '100%', height: '100%', objectFit: 'contain', filter: 'drop-shadow(0 0 10px rgba(245, 245, 220, 0.3))' }}
              />
            </div>
          </div>

          <div className="fade-in-up fade-in-up-delay-1" style={{ position: 'relative' }}>
            <h1 style={{
              fontSize: 'clamp(2rem, 5.5vw, 3.5rem)',
              fontWeight: '500', letterSpacing: '0.02em', lineHeight: '1.15',
              color: '#f5f5dc',
              textShadow: '0 0 1px #f5f5dc, 0 0 3px rgba(245, 245, 220, 0.6)',
              marginBottom: '1.5rem', position: 'relative', zIndex: 2
            }}>
              MASTER AI WITH A SUPER USER IN YOUR CORNER
            </h1>
            <div style={{
              position: 'absolute', top: '-10px', left: '-10px', right: '-10px', bottom: '-10px', zIndex: 1,
              backgroundImage: `linear-gradient(rgba(245, 245, 220, 0.12) 0.5px, transparent 0.5px), linear-gradient(90deg, rgba(245, 245, 220, 0.12) 0.5px, transparent 0.5px)`,
              backgroundSize: '12px 12px', animation: 'wireframeShift 8s linear infinite', opacity: 0.5
            }}></div>
            <div style={{ position: 'absolute', top: '5%', left: '3%', width: '15px', height: '15px', border: '1px solid rgba(245, 245, 220, 0.4)', borderRight: 'none', borderBottom: 'none', animation: 'pulseCorner 3s ease-in-out infinite' }}></div>
            <div style={{ position: 'absolute', top: '5%', right: '3%', width: '15px', height: '15px', border: '1px solid rgba(245, 245, 220, 0.4)', borderLeft: 'none', borderBottom: 'none', animation: 'pulseCorner 3s ease-in-out infinite 0.5s' }}></div>
            <div style={{ position: 'absolute', bottom: '5%', left: '3%', width: '15px', height: '15px', border: '1px solid rgba(245, 245, 220, 0.4)', borderRight: 'none', borderTop: 'none', animation: 'pulseCorner 3s ease-in-out infinite 1s' }}></div>
            <div style={{ position: 'absolute', bottom: '5%', right: '3%', width: '15px', height: '15px', border: '1px solid rgba(245, 245, 220, 0.4)', borderLeft: 'none', borderTop: 'none', animation: 'pulseCorner 3s ease-in-out infinite 1.5s' }}></div>
          </div>

          <p className="fade-in-up fade-in-up-delay-2" style={{
            fontSize: 'clamp(1rem, 2.2vw, 1.25rem)', fontWeight: '400',
            color: 'rgba(245, 245, 220, 0.75)', lineHeight: '1.6',
            marginBottom: '3rem', maxWidth: '600px', margin: '0 auto 3rem'
          }}>
            1-on-1 AI coaching & mentorship — integrate AI into your daily life, your business, and your edge. Guided by an AI super user with real engineering experience, not just theory.
          </p>

          <div className="fade-in-up fade-in-up-delay-3" style={{ display: 'flex', gap: '1.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href={CALENDLY_LINK} target="_blank" rel="noopener noreferrer" className="hp-cta-button">BOOK FREE STRATEGY CALL</a>
            <a href="#offer" className="hp-cta-outline">SEE WHAT'S INCLUDED</a>
          </div>
        </div>
      </section>

      {/* ====== PROBLEM ====== */}
      <section style={{ padding: '6rem 2rem', maxWidth: '800px', margin: '0 auto' }}>
        <div className="section-divider"></div>
        <h2 style={{ fontSize: 'clamp(1.5rem, 3.5vw, 2.2rem)', fontWeight: '500', color: '#f5f5dc', textAlign: 'center', marginBottom: '1rem', letterSpacing: '0.02em' }}>
          You've Spent Thousands on AI and Still Have Nothing to Show For It
        </h2>
        <p style={{ textAlign: 'center', color: 'rgba(245, 245, 220, 0.5)', marginBottom: '3rem', fontSize: '0.95rem' }}>sound familiar?</p>
        
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          {[
            "You've spent thousands on AI credits, subscriptions and premium plans — and still can't point to a single thing that's actually working in your business",
            "Every week you burn hours wrestling with prompts, watching tutorials, and testing new AI setups that never quite deliver what you imagined",
            "You had the idea months ago but you're still not at market — stuck in an endless loop of tweaking, rebuilding, and starting over with a different approach",
            "The gap between what AI promises and what you're actually getting feels embarrassing — you know it should be easier but you can't crack it alone",
            "You've invested serious time and money into figuring this out yourself, and the result is a graveyard of half-built projects, expired trials, and wasted weekends"
          ].map((point, i) => (
            <div key={i} className="pain-point">
              <p style={{ color: 'rgba(245, 245, 220, 0.8)', fontSize: '1.05rem', lineHeight: '1.6' }}>{point}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ====== RESULTS ====== */}
      <section style={{ padding: '6rem 2rem', borderTop: '1px solid rgba(245, 245, 220, 0.08)' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div className="section-divider"></div>
          <h2 style={{ fontSize: 'clamp(1.5rem, 3.5vw, 2.2rem)', fontWeight: '500', color: '#f5f5dc', textAlign: 'center', marginBottom: '3rem', letterSpacing: '0.02em' }}>
            What Life Looks Like With AI Dialled In
          </h2>
          <div className="results-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1.5rem' }}>
            {results.map((r, i) => (
              <div key={i} className="result-card">
                <div style={{ fontSize: 'clamp(1.8rem, 3vw, 2.5rem)', fontWeight: '600', color: '#f5f5dc', marginBottom: '0.5rem', letterSpacing: '-0.02em' }}>{r.metric}</div>
                <div style={{ fontSize: '0.85rem', color: 'rgba(245, 245, 220, 0.6)', lineHeight: '1.4', textTransform: 'lowercase' }}>{r.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ====== WHAT WE INSTALL ====== */}
      <section style={{ padding: '6rem 2rem', borderTop: '1px solid rgba(245, 245, 220, 0.08)' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div className="section-divider"></div>
          <h2 style={{ fontSize: 'clamp(1.5rem, 3.5vw, 2.2rem)', fontWeight: '500', color: '#f5f5dc', textAlign: 'center', marginBottom: '0.75rem', letterSpacing: '0.02em' }}>
            What We Actually Install
          </h2>
          <p style={{ textAlign: 'center', color: 'rgba(245, 245, 220, 0.5)', marginBottom: '3rem', fontSize: '0.95rem', maxWidth: '600px', margin: '0 auto 3rem' }}>
            This isn't theory. These are real systems we set up, test, and embed into your daily life — using proven, cost-effective methods that don't require enterprise budgets.
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '1.5rem' }}>
            {[
              { icon: "⚡", title: "AI-Powered Daily Workflow", items: ["Morning briefing agent — news, calendar, priorities generated automatically", "AI email drafting and inbox triage", "Voice-to-action: capture ideas and turn them into tasks, content, or decisions", "Smart note-taking and knowledge management"] },
              { icon: "🏗️", title: "Business Automation", items: ["No-code AI automations — zero developer cost", "AI customer response and lead qualification systems", "Automated reporting and data insights", "Process mapping → AI replacement for repetitive tasks"] },
              { icon: "🎯", title: "AI Content Engine", items: ["Content ideation → writing → editing pipeline using AI at every stage", "Social media content generation tailored to each platform", "AI image and video creation for marketing — no designer needed", "Repurposing system: one idea → 10+ pieces of content"] },
              { icon: "📡", title: "Stay Ahead System", items: ["Curated AI news feed — only what actually matters, filtered from noise", "Tool evaluation framework: test new AI tools in minutes, not weeks", "Trend radar: know what's coming before your competitors do", "Community and source list used by real AI super users"] },
              { icon: "🧠", title: "AI-Powered Decisions", items: ["Research and analysis agents that synthesise information in seconds", "AI-assisted financial tracking and forecasting", "Scenario modelling for business decisions", "Personal AI assistant configured to your context and preferences"] },
              { icon: "🔧", title: "Cost-Effective Stack", items: ["Free and low-cost tools that outperform expensive alternatives", "Open-source AI options for privacy-conscious setups", "Pay-for-what-you-use architectures — no bloated subscriptions", "DIY setups that replace £500+/month SaaS tools"] }
            ].map((block, i) => (
              <div key={i} className="install-card">
                <div style={{ fontSize: '1.8rem', marginBottom: '1rem' }}>{block.icon}</div>
                <h3 style={{ color: '#f5f5dc', fontSize: '1.05rem', fontWeight: '600', marginBottom: '1rem', letterSpacing: '0.01em' }}>{block.title}</h3>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {block.items.map((item, j) => (
                    <li key={j} style={{ color: 'rgba(245, 245, 220, 0.6)', fontSize: '0.85rem', lineHeight: '1.5', marginBottom: '0.6rem', paddingLeft: '1rem', position: 'relative' }}>
                      <span style={{ position: 'absolute', left: 0, color: 'rgba(245, 245, 220, 0.35)' }}>—</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <p style={{ textAlign: 'center', color: 'rgba(245, 245, 220, 0.4)', marginTop: '2.5rem', fontSize: '0.85rem', fontStyle: 'italic' }}>
            Every system is built using proven, cost-effective methods. Most clients spend under £50/month on tools after setup.
          </p>
        </div>
      </section>

      {/* ====== HOW IT WORKS ====== */}
      <section style={{ padding: '6rem 2rem', borderTop: '1px solid rgba(245, 245, 220, 0.08)' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <div className="section-divider"></div>
          <h2 style={{ fontSize: 'clamp(1.5rem, 3.5vw, 2.2rem)', fontWeight: '500', color: '#f5f5dc', textAlign: 'center', marginBottom: '3rem', letterSpacing: '0.02em' }}>
            How It Works
          </h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '2.5rem' }}>
            {[
              { num: "01", title: "Book a free discovery call", desc: "15 minutes. No pitch, no pressure. We'll dig into what you're trying to build, where AI is costing you time and money instead of saving it, and whether this mentorship is actually the right fit. If it's not, I'll tell you." },
              { num: "02", title: "Get your personalised AI blueprint", desc: "Before we even start, I'll map out a clear plan — exactly what we'll build, which workflows to install first, and the fastest path from where you are now to a working, AI-powered system. You'll know the game plan before you spend a penny." },
              { num: "03", title: "Enrol and we build it together", desc: "Pay once (£1,497) or book a 2-payment plan on the call. Then we get to work — 4 weekly 1-on-1 sessions where we implement AI into your actual business and life. Not theory. We build real systems, live, together. Plus 30 days of async support between sessions so you're never stuck." },
              { num: "04", title: "Launch, operate, and stay ahead", desc: "By day 30, you'll have AI embedded into your daily workflow, your content, your decisions — and the knowledge to keep evolving it yourself. No more wasted credits. No more half-built projects. You'll be the person others ask for AI advice." }
            ].map((step, i) => (
              <div key={i} style={{ display: 'flex', gap: '1.5rem', alignItems: 'flex-start' }}>
                <div className="step-number">{step.num}</div>
                <div>
                  <h3 style={{ color: '#f5f5dc', fontSize: '1.15rem', fontWeight: '600', marginBottom: '0.5rem' }}>{step.title}</h3>
                  <p style={{ color: 'rgba(245, 245, 220, 0.65)', fontSize: '0.95rem', lineHeight: '1.6' }}>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ====== OFFER ====== */}
      <section id="offer" style={{ padding: '6rem 2rem', borderTop: '1px solid rgba(245, 245, 220, 0.08)' }}>
        <div style={{ maxWidth: '700px', margin: '0 auto' }}>
          <div className="section-divider"></div>
          <h2 style={{ fontSize: 'clamp(1.5rem, 3.5vw, 2.2rem)', fontWeight: '500', color: '#f5f5dc', textAlign: 'center', marginBottom: '0.5rem', letterSpacing: '0.02em' }}>
            AI Coaching & Mentorship
          </h2>
          <p style={{ textAlign: 'center', color: 'rgba(245, 245, 220, 0.5)', marginBottom: '3rem', fontSize: '0.95rem' }}>
            4 weeks of 1-on-1 coaching to integrate AI into your life, your business, and your competitive edge
          </p>

          <div style={{ border: '1px solid rgba(245, 245, 220, 0.25)', padding: 'clamp(2rem, 4vw, 3rem)', position: 'relative' }}>
            <div style={{
              position: 'absolute', top: '-14px', left: '50%', transform: 'translateX(-50%)',
              background: '#f5f5dc', color: '#000', padding: '6px 20px',
              fontSize: '0.75rem', fontWeight: '700', letterSpacing: '0.08em', textTransform: 'uppercase'
            }}>
              FOUNDING MEMBER PRICE
            </div>

            <div style={{ textAlign: 'center', marginBottom: '2.5rem', marginTop: '1rem' }}>
              <div style={{ fontSize: '0.95rem', color: 'rgba(245, 245, 220, 0.45)', textDecoration: 'line-through', marginBottom: '0.25rem' }}>£2,497</div>
              <div style={{ fontSize: 'clamp(2.5rem, 5vw, 3.5rem)', fontWeight: '600', color: '#f5f5dc', letterSpacing: '-0.02em' }}>£1,497</div>
              <div style={{ fontSize: '0.85rem', color: 'rgba(245, 245, 220, 0.5)', marginTop: '0.25rem' }}>one-time payment · limited spots</div>
            </div>

            <div style={{ marginBottom: '2.5rem' }}>
              <h3 style={{ color: '#f5f5dc', fontSize: '1rem', fontWeight: '600', marginBottom: '1.5rem', letterSpacing: '0.05em', textTransform: 'uppercase' }}>What's Included</h3>
              {[
                "4× weekly 60-minute 1-on-1 coaching & mentorship calls",
                "Personalised AI blueprint — daily life, business, and creative workflows",
                "Done-with-you AI automations, agents, and content systems",
                "Custom prompt library and workflow templates for your niche",
                "AI trend briefings — stay ahead with curated updates on what actually matters",
                "30 days of unlimited async support (WhatsApp/Telegram)",
                "Recordings of every session — yours to keep forever",
                "30-day results guarantee — or I coach you free until you get them"
              ].map((item, i) => (
                <div key={i} className="included-item">
                  <span className="checkmark">✓</span>
                  <span style={{ color: 'rgba(245, 245, 220, 0.8)', fontSize: '0.95rem', lineHeight: '1.5' }}>{item}</span>
                </div>
              ))}
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', alignItems: 'center' }}>
              <a href={STRIPE_PAYMENT_LINK} target="_blank" rel="noopener noreferrer" className="hp-cta-button" style={{ width: '100%', maxWidth: '400px', textAlign: 'center' }}>
                ENROL NOW — £1,497
              </a>
              <a href={CALENDLY_LINK} target="_blank" rel="noopener noreferrer" className="hp-cta-outline" style={{ width: '100%', maxWidth: '400px', textAlign: 'center' }}>
                OR BOOK A FREE CALL FIRST
              </a>
              <p style={{ fontSize: '0.8rem', color: 'rgba(245, 245, 220, 0.35)', marginTop: '0.5rem' }}>
                Secure payment via Stripe · Founding price available for a limited time
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ====== ABOUT ====== */}
      <section style={{ padding: '6rem 2rem', borderTop: '1px solid rgba(245, 245, 220, 0.08)' }}>
        <div style={{ maxWidth: '700px', margin: '0 auto' }}>
          <div className="section-divider"></div>
          <h2 style={{ fontSize: 'clamp(1.5rem, 3.5vw, 2.2rem)', fontWeight: '500', color: '#f5f5dc', textAlign: 'center', marginBottom: '3rem', letterSpacing: '0.02em' }}>
            Who's Behind This
          </h2>
          <div style={{ textAlign: 'center' }}>
            <p style={{ color: 'rgba(245, 245, 220, 0.8)', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '1.5rem' }}>
              I'm not an AI influencer who discovered ChatGPT last year. I'm an AI super user with real engineering experience — DevOps, platform engineering, and infrastructure at scale. I use AI every single day to generate content, extract insights, automate systems, and make better decisions faster.
            </p>
            <p style={{ color: 'rgba(245, 245, 220, 0.6)', fontSize: '0.95rem', lineHeight: '1.7', marginBottom: '1.5rem' }}>
              6+ years in financial infrastructure. Quantitative trading background. I've built systems that handle real money and real decisions — and now I build AI-powered workflows that do the same for my clients.
            </p>
            <p style={{ color: 'rgba(245, 245, 220, 0.6)', fontSize: '0.95rem', lineHeight: '1.7' }}>
              I don't just know what tools exist — I know which ones actually matter, how they connect, and how to make them work for your specific situation. That's the difference between watching tutorials and having a mentor.
            </p>
          </div>
        </div>
      </section>

      {/* ====== FAQ ====== */}
      <section style={{ padding: '6rem 2rem', borderTop: '1px solid rgba(245, 245, 220, 0.08)' }}>
        <div style={{ maxWidth: '700px', margin: '0 auto' }}>
          <div className="section-divider"></div>
          <h2 style={{ fontSize: 'clamp(1.5rem, 3.5vw, 2.2rem)', fontWeight: '500', color: '#f5f5dc', textAlign: 'center', marginBottom: '3rem', letterSpacing: '0.02em' }}>
            Questions
          </h2>
          {faqs.map((faq, i) => (
            <div key={i} className="faq-item" onClick={() => setExpandedFaq(expandedFaq === i ? null : i)} style={{ padding: '1.5rem 0' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3 style={{ color: '#f5f5dc', fontSize: '1rem', fontWeight: '500', flex: 1, paddingRight: '1rem' }}>{faq.q}</h3>
                <span style={{ color: '#f5f5dc', fontSize: '1.5rem', transform: expandedFaq === i ? 'rotate(45deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease', flexShrink: 0 }}>+</span>
              </div>
              <div style={{ maxHeight: expandedFaq === i ? '200px' : '0', overflow: 'hidden', transition: 'all 0.4s ease', opacity: expandedFaq === i ? 1 : 0 }}>
                <p style={{ color: 'rgba(245, 245, 220, 0.6)', fontSize: '0.9rem', lineHeight: '1.7', paddingTop: '1rem' }}>{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ====== EMAIL CAPTURE ====== */}
      <section style={{ padding: '6rem 2rem', borderTop: '1px solid rgba(245, 245, 220, 0.08)' }}>
        <div style={{ maxWidth: '500px', margin: '0 auto', textAlign: 'center' }}>
          <h2 style={{ fontSize: 'clamp(1.3rem, 3vw, 1.8rem)', fontWeight: '500', color: '#f5f5dc', marginBottom: '0.75rem', letterSpacing: '0.02em' }}>
            Not Ready Yet?
          </h2>
          <p style={{ color: 'rgba(245, 245, 220, 0.55)', fontSize: '0.95rem', marginBottom: '2rem', lineHeight: '1.6' }}>
            Get my free guide: "The AI Super User Starter Kit — 7 workflows that will change how you work and live this week."
          </p>
          <div id="ck_embed_form" style={{ width: '100%', display: 'flex', justifyContent: 'center' }}></div>
        </div>
      </section>

      {/* ====== FINAL CTA ====== */}
      <section style={{ padding: '6rem 2rem', borderTop: '1px solid rgba(245, 245, 220, 0.08)', textAlign: 'center' }}>
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <h2 style={{ fontSize: 'clamp(1.5rem, 3.5vw, 2.2rem)', fontWeight: '500', color: '#f5f5dc', marginBottom: '1rem', letterSpacing: '0.02em' }}>
            Everyone's Talking About AI. Few Are Actually Using It.
          </h2>
          <p style={{ color: 'rgba(245, 245, 220, 0.6)', fontSize: '1rem', marginBottom: '2.5rem', lineHeight: '1.6' }}>
            The gap between people who understand AI and those who don't grows every single week. In 30 days, you'll be on the right side of it — with a mentor who lives there.
          </p>
          <div style={{ display: 'flex', gap: '1.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href={STRIPE_PAYMENT_LINK} target="_blank" rel="noopener noreferrer" className="hp-cta-button">ENROL NOW — £1,497</a>
            <a href={CALENDLY_LINK} target="_blank" rel="noopener noreferrer" className="hp-cta-outline">BOOK FREE CALL</a>
          </div>
        </div>
      </section>

      {/* ====== FOOTER ====== */}
      <footer style={{ padding: '3rem 2rem', borderTop: '1px solid rgba(245, 245, 220, 0.08)', textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1.5rem' }}>
          <img 
            src="/images/ChatGPT_Image_Jun_5__2025__01_11_15_PM-removebg-preview.png"
            alt="Fullness Life"
            style={{ width: '40px', height: '40px', objectFit: 'contain', opacity: 0.6 }}
          />
        </div>
        <p style={{ color: 'rgba(245, 245, 220, 0.3)', fontSize: '0.8rem' }}>
          © {new Date().getFullYear()} Fullness Life. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default HomePage;
